import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import {
  CATALOG_FILTERS_TYPE_COLOR,
  CATALOG_FILTERS_TYPE_RANGE,
  CATALOG_FILTERS_TYPE_COMMON,
} from 'store/ProductCatalog/constants';
import { getFiltersArray } from 'store/ProductCatalog/filters/selectors';

import RangeFilter from './components/RangeFilter';
import CommonFilter from './components/CommonFilter';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Switch for layouts of Filter Groups of different types
 */
export function FilterSwitch({ slug, type, isMobile, className }) {
  switch (type) {
    case CATALOG_FILTERS_TYPE_RANGE:
      return <RangeFilter {...{ slug, isMobile, className }} />;
    case CATALOG_FILTERS_TYPE_COLOR:
    case CATALOG_FILTERS_TYPE_COMMON:
    default:
      return <CommonFilter {...{ slug, isMobile, className, type }} />;
  }
}

FilterSwitch.propTypes = {
  slug: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

/**
 * Layout for filters, renders array of all filters in sidebar
 */
export function FiltersLayout({ filtersArray, isMobile, className }) {
  return (
    <div className={cx('container')}>
      {filtersArray.length !== 0 &&
        filtersArray.map(({ slug, type }) => (
          <FilterSwitch key={slug} {...{ slug, type, isMobile, className }} />
        ))}
    </div>
  );
}

FiltersLayout.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  filtersArray: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      type: PropTypes.string,
      isOpen: PropTypes.bool, // isOptional, for initial open state
      min: PropTypes.number, // isOptional, for range type only
      max: PropTypes.number, // isOptional, for range type only
      options: PropTypes.arrayOf(
        PropTypes.shape({
          // for common and color types
          name: PropTypes.string,
          slug: PropTypes.string,
          resultCount: PropTypes.number,
          color: PropTypes.string, // isOptional, for color type only
        }),
      ),
    }),
  ),
};

const mapStateToProps = (state) => ({
  filtersArray: getFiltersArray(state),
});

const FiltersWidget = connect(mapStateToProps)(FiltersLayout);
FiltersWidget.propTypes = {};
export default FiltersWidget;
